import { apiService } from './api';

export const productService = {
  // Récupérer tous les produits
  getProducts: async (params = {}) => {
    const response = await apiService.get('/products', params);
    return response.data;
  },

  // Récupérer un produit par ID
  getProduct: async (id) => {
    const response = await apiService.get(`/products/${id}`);
    return response.data;
  },

  // Récupérer un produit par code-barres
  getProductByBarcode: async (barcode) => {
    const response = await apiService.get(`/products/barcode/${barcode}`);
    return response.data;
  },

  // Créer un nouveau produit
  createProduct: async (productData) => {
    const response = await apiService.post('/products', productData);
    return response.data;
  },

  // Mettre à jour un produit
  updateProduct: async (id, productData) => {
    const response = await apiService.put(`/products/${id}`, productData);
    return response.data;
  },

  // L'historique unifié d'un produit — entrées et sorties, triées et paginées
  // SUR L'ENSEMBLE par le serveur (`GET /products/<id>/movements`).
  // ⚠️ Une seule requête, et c'est le point : deux appels fusionnés côté client
  // plafonneraient à 5 par famille, donc ne pourraient pas paginer du tout.
  getProductMovements: async (id, params = {}) => {
    const response = await apiService.get(`/products/${id}/movements`, params);
    return response.data;
  },

  // Les LIGNES de commande portant ce produit — « chez qui, et à quel prix ».
  // ⚠️ Des LIGNES, pas des commandes : un même produit peut figurer deux fois
  // dans la même commande (mesuré en base), et grouper en perdrait une.
  getProductPurchaseOrders: async (id, params = {}) => {
    const response = await apiService.get(`/products/${id}/purchase-orders`, params);
    return response.data;
  },

  // Supprimer un produit
  deleteProduct: async (id) => {
    const response = await apiService.delete(`/products/${id}`);
    return response.data;
  },

  // Upload d'image pour un produit
  uploadProductImage: async (productId, file) => {
    const formData = new FormData();
    formData.append('image', file);
    
    const response = await apiService.upload(`/products/upload-image/${productId}`, formData);
    return response.data;
  },

  // Générer un nouveau code-barres
  generateBarcode: async () => {
    const response = await apiService.post('/products/generate-barcode');
    return response.data;
  },
}; 